/** jQuery UI datepicker / timepicker locales (from legacy vendor.includes.js). */

const $ = window.jQuery;

if ($ && $.datepicker) {
    $.datepicker.regional.cs = {
        year: 'Rok',
        prevYear: 'Předchozí rok',
        nextYear: 'Následující rok',
        closeText: 'Zavřít',
        prevText: 'Předchozí',
        nextText: 'Další',
        currentText: 'Dnes',
        monthNames: [
            'Leden', 'Únor', 'Březen', 'Duben', 'Květen', 'Červen',
            'Červenec', 'Srpen', 'Září', 'Říjen', 'Listopad', 'Prosinec',
        ],
        monthNamesShort: [
            'Led', 'Úno', 'Bře', 'Dub', 'Kvě', 'Čer',
            'Čnc', 'Srp', 'Zář', 'Říj', 'Lis', 'Pro',
        ],
        dayNames: ['Neděle', 'Pondělí', 'Úterý', 'Středa', 'Čtvrtek', 'Pátek', 'Sobota'],
        dayNamesShort: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
        dayNamesMin: ['Ne', 'Po', 'Út', 'St', 'Čt', 'Pá', 'So'],
        weekHeader: 'Týden',
        dateFormat: 'dd.mm.yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
    };

    $.datepicker.regional.sk = {
        year: 'Rok',
        prevYear: 'Predchádzajúci rok',
        nextYear: 'Nasledujúci rok',
        closeText: 'Zavrieť',
        prevText: 'Predchádzajúci',
        nextText: 'Nasledujúci',
        currentText: 'Dnes',
        monthNames: [
            'Január', 'Február', 'Marec', 'Apríl', 'Máj', 'Jún',
            'Júl', 'August', 'September', 'Október', 'November', 'December',
        ],
        monthNamesShort: [
            'Jan', 'Feb', 'Mar', 'Apr', 'Máj', 'Jún',
            'Júl', 'Aug', 'Sep', 'Okt', 'Nov', 'Dec',
        ],
        dayNames: ["Nedeľa", 'Pondelok', 'Utorok', 'Streda', 'Štvrtok', 'Piatok', 'Sobota'],
        dayNamesShort: ['Ned', 'Pon', 'Uto', 'Str', 'Štv', 'Pia', 'Sob'],
        dayNamesMin: ['Ne', 'Po', 'Ut', 'St', 'Št', 'Pi', 'So'],
        weekHeader: 'Ty',
        dateFormat: 'dd.mm.yy',
        firstDay: 1,
        isRTL: false,
        showMonthAfterYear: false,
        yearSuffix: '',
    };

    if ($.timepicker) {
        $.timepicker.regional.cs = {
            timeOnlyTitle: 'Pouze čas',
            timeText: 'Čas',
            hourText: 'Hodiny',
            minuteText: 'Minuty',
            secondText: 'Vteřiny',
            millisecText: 'Milisekundy',
            timezoneText: 'Timezone',
            currentText: 'Nyní',
            closeText: 'Zavřít',
            timeFormat: 'HH:mm',
            amNames: ['AM', 'A'],
            pmNames: ['PM', 'P'],
            isRTL: false,
        };

        $.timepicker.regional.sk = {
            timeOnlyTitle: 'Iba čas',
            timeText: 'Čas',
            hourText: 'Hodiny',
            minuteText: 'Minúty',
            secondText: 'Sekundy',
            millisecText: 'Milisekundy',
            timezoneText: 'Timezone',
            currentText: 'Teraz',
            closeText: 'Zavrieť',
            timeFormat: 'HH:mm',
            amNames: ['AM', 'A'],
            pmNames: ['PM', 'P'],
            isRTL: false,
        };
    }
}
